module.exports = __webpack_public_path__ + "static/media/AllM.8ab88505.jpg";